module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\r\n    <h3>Dar Permisos en las secciones</h3>\r\n</div>\r\n\r\n\r\n        \r\n\r\n    ';

    
    for(var p in permissions){
        
__p+='\r\n    <table style="border: 1px solid red; " class="table-bordered center_elemmxx  ">\r\n        <thead>\r\n            <td></td>\r\n            <td></td>\r\n            ';

   
        print('<td> '+lang.DESCRIPTIVOS_MAI+'   </td>'); 
        print('<td> '+lang.DOCUMENTOS+'  </td>'); 
        print('<td> '+lang.ECONOMICOS_MAI+'  </td>'); 
        print('<td> '+lang.GPS_MAI+'  </td>'); 
        print('<td> '+lang.AMPLIADA_MAI+'  </td>'); 
        print('<td> '+lang.JURIDICOS_MAI+'  </td>'); 
        print('<td> '+lang.MEJORAS+'  </td>'); 
        print('<td> '+lang.REGISTRALES+'  </td>'); 
        print('<td> '+lang.SEGUROS_MAI+'  </td>'); 
        print('<td> '+lang.TITULOS+'  </td>'); 
        print('<td> '+lang.URBANISTICOS_MAI+'  </td>'); 
        print('<td> '+lang.ACUERDOS+'  </td>'); 
        print('<td> '+lang.CATASTRALES_G_MAI+'  </td>'); 
 
        
__p+='\r\n        </thead>\r\n        ';



        var perm = permissions[p];
        print('<tr id="' + p + '"  data-itemarea="' + perm.area + '"  class="epigraph">');
        print('<td>' + lang[perm.area] + '</td>');
        print('<td></td>');
                

        print('<td><input type="checkbox" class="descriptivos"       /></td>'); 
        print('<td><input type="checkbox" class="documentos"      /></td>'); 
        print('<td><input type="checkbox" class="economicos"     /></td>'); 
        print('<td><input type="checkbox" class="gps"     /></td>'); 
        print('<td><input type="checkbox" class="incidencias"   /></td>'); 
        print('<td><input type="checkbox" class="juridicos"     /></td>'); 
        print('<td><input type="checkbox" class="mejoras"    /></td>'); 
        print('<td><input type="checkbox" class="registrales"   /></td>'); 
        print('<td><input type="checkbox" class="seguros"     /></td>'); 
        print('<td><input type="checkbox" class="titulos"     /></td>'); 
        print('<td><input type="checkbox" class="urbanisticos"      /></td>'); 
        print('<td><input type="checkbox" class="acuerdos"    /></td>'); 
        print('<td><input type="checkbox" class="catastrales"     /></td>'); 
        
       

        
        print('</tr>');
       
        for (var c in perm.children){
            var subPerm = perm.children[c];
 

            print('<tr id="' + subPerm.id + '" data-parent="' + subPerm.parent_id + '"  data-item="' + subPerm.area + '" class="subepigraph">');
            print('<td></td>');
            print('<td class="lef_aliii" >' + lang[subPerm.area] + '</td>');
            
            var Descricheck = subPerm.descriptivos == 1 ? "checked" : '';
            var documenCheck = subPerm.documentos == 1 ? "checked" : '';
            var EconoCheck = subPerm.economicos == 1 ? "checked" : '';
            var GpsCheck = subPerm.gps == 1 ? "checked" : ''; 
            var IncidCheck = subPerm.incidencias == 1 ? "checked" : ''; 
            var JuridCheck = subPerm.juridicos == 1 ? "checked" : ''; 
            var Mejorcheck = subPerm.mejoras == 1 ? "checked" : ''; 
            var RegistCheck = subPerm.registrales == 1 ? "checked" : ''; 
            var SeguroCheck = subPerm.seguros == 1 ? "checked" : ''; 
            var titulcheck = subPerm.titulos == 1 ? "checked" : ''; 
            var Urbaccheck = subPerm.urbanisticos == 1 ? "checked" : ''; 
            var AcuerCheck = subPerm.acuerdos == 1 ? "checked" : ''; 
            var CatacCheck = subPerm.catastrales == 1 ? "checked" : ''; 
            

          

            print('<td><input type="checkbox" class="descriptivos"   '+Descricheck+'   /></td>'); 
            print('<td><input type="checkbox" class="documentos"   '+documenCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="economicos"   '+EconoCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="gps"   '+GpsCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="incidencias"   '+IncidCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="juridicos"   '+JuridCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="mejoras"   '+Mejorcheck+'   /></td>'); 
            print('<td><input type="checkbox" class="registrales"   '+RegistCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="seguros"   '+SeguroCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="titulos"   '+titulcheck+'   /></td>'); 
            print('<td><input type="checkbox" class="urbanisticos"   '+Urbaccheck+'   /></td>'); 
            print('<td><input type="checkbox" class="acuerdos"   '+AcuerCheck+'   /></td>'); 
            print('<td><input type="checkbox" class="catastrales"   '+CatacCheck+'   /></td>'); 
              
            print('</tr>');

            
        }
        
__p+='\r\n    </table>\r\n    ';
 
    }

    if(role_user < 1){
    
__p+='\r\n\r\n\r\n        <div id="sendForm" class="form-group col-xs-11 text-right">\r\n            <br>\r\n            <span class="btn btn-sm btn-success btn-flat" id="send">'+
((__t=(lang.SEND))==null?'':_.escape(__t))+
'</span>\r\n            <br>\r\n            <div id="load_giggg" style="display: none; ">\r\n                <i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i> Loading..\r\n            </div>\r\n\r\n        </div>\r\n    ';
}
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/sections/sectionsList.ejs
// module id = 452
// module chunks = 0